<template>
  <div class="table-card rounded-xl">
    <div class="card-head">
      <div>
        <h3 class="text-subtitle-2 font-weight-bold" style="color: #0009;">
          Ringkasan Per Bulan
        </h3>
        <!-- <span class="table-card__subtitle">Data singkat untuk monitoring pelaksanaan pembangunan</span> -->
      </div>
      <span class="table-badge">Rekap</span>
    </div>
    <div class="table-wrap">
      <table class="monthly-table">
        <thead>
          <tr>
            <th>Bulan</th>
            <th>Target</th>
            <th>Realisasi</th>
            <th>Deviasi</th>
            <th>Anggaran Murni</th>
            <th>Anggaran P1</th>
            <th style="min-width: 200px;">Anggaran Perubahan</th>
            <th style="min-width: 300px;">Anggaran Kas Perbulan (Rp)</th>
            <th style="min-width: 350px;">Persentase SP2D terhadap Pagu Anggaran</th>
            <th style="min-width: 300px;">Realisasi Keuangan/SP2D (Rp)</th>
            <th style="min-width: 350px;">Persentase SP2D terhadap Kas Perbulan</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, idx) in normalizedRows"
            :key="`${row.bulan}-${idx}`">
            <td>{{ row.bulan }}</td>
            <td>{{ row.target }}</td>
            <td>{{ row.realisasi }}</td>
            <td>{{ row.deviasi }}</td>
            <td>{{ row.anggaranMurni }}</td>
            <td>{{ row.anggaranP1 }}</td>
            <td>{{ row.anggaranPerubahan }}</td>
            <td>{{ row.anggaranKasPerBulan }}</td>
            <td>{{ row.persentaseSp2dPagu }}</td>
            <td>{{ row.realisasiKeuanganSp2d }}</td>
            <td>{{ row.persentaseSp2dKasPerBulan }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
const MONTHS = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
]

export default {
  name: 'SimpelbangMonthlyTable',
  props: {
    grafikRows: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    normalizedRows() {
      const rows = Array.isArray(this.grafikRows) ? [...this.grafikRows] : []
      return rows
        .sort((a, b) => this.toNumber(a?.month ?? a?.bulan_anggaran) - this.toNumber(b?.month ?? b?.bulan_anggaran))
        .map((row) => {
          const monthNumber = this.toNumber(row?.month ?? row?.bulan_anggaran)
          return {
            bulan: MONTHS[Math.max(0, Math.min(11, monthNumber - 1))] || '-',
            target: this.formatPercent(row?.target_fisik),
            realisasi: this.formatPercent(row?.realisasi_fisik),
            deviasi: this.formatPercent(row?.deviasi_fisik),
            anggaranMurni: this.formatCurrency(row?.anggaran_murni),
            anggaranP1: this.formatCurrency(row?.anggaran_p1),
            anggaranPerubahan: this.formatCurrency(row?.anggaran_perubahan),
            anggaranKasPerBulan: this.formatCurrency(row?.kas_per_bulan),
            persentaseSp2dPagu: this.formatPercent(row?.persentase_sp2d_pagu),
            realisasiKeuanganSp2d: this.formatCurrency(row?.realisasi_keuangan_sp2d),
            persentaseSp2dKasPerBulan: this.formatPercent(row?.persentase_sp2d_kas_bulanan)
          }
        })
    }
  },
  methods: {
    toNumber(value) {
      const n = Number(value)
      return Number.isFinite(n) ? n : 0
    },
    formatPercent(value) {
      const n = Number(value)
      if (!Number.isFinite(n)) return '-'
      return `${new Intl.NumberFormat('id-ID', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(n)}%`
    },
    formatCurrency(value) {
      const n = Number(value)
      if (!Number.isFinite(n) || n === 0) return '-'
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0
      }).format(n)
    }
  }
}
</script>

<style scoped>
.table-card {
  background: #ffffff;
  border: 1px solid rgba(21, 73, 135, 0.12);
  /* border-radius: 24px; */
  padding: 18px;
}

.card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.table-card__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #16324f;
  letter-spacing: -0.01em;
}

.table-card__subtitle {
  display: block;
  margin-top: 6px;
  color: #6f7f92;
  font-size: 12px;
  line-height: 1.45;
}

.table-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
  background: rgba(23, 87, 184, 0.1);
  color: #1757b8;
  flex-shrink: 0;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.monthly-table {
  width: 100%;
  min-width: 1280px;
  border-collapse: collapse;
  margin-top: 6px;
}

.monthly-table th,
.monthly-table td {
  text-align: left;
  padding: 12px 10px;
  border-bottom: 1px solid rgba(20, 78, 136, 0.08);
  font-size: 13px;
  color: #16324f;
}

.monthly-table th {
  color: #6f7f92;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.monthly-table th:first-child,
.monthly-table td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  background: #ffffff;
}

.monthly-table th:first-child {
  z-index: 3;
}
</style>
